//  @flow

import type {CrmCustomer} from '../../../entities';
import {useSelector} from 'react-redux';

import type {RootState} from '../..';
import {useActions} from '../../../utils/globalStore';

import {actions} from '../duck';
import {useEffect} from 'react';

export const getCustomerFirstName = (customer: CrmCustomer) => {
  const fullName = customer ? customer.fullName : '';
  if (fullName) {
    const sp = fullName.split(' ');
    if (sp && sp[0]) return sp[0];
  }
  return '';
};

const crmCustomerCategoriesSelector = (state: RootState) =>
  state.crm.categories;

export function useCrmCustomerCategories() {
  return useSelector(crmCustomerCategoriesSelector);
}

export function useInitializeCrmCustomerCategories() {
  const fetchCustomerCategories = useActions(actions.fetchCustomerCategories);

  useEffect(() => {
    fetchCustomerCategories();
  }, [fetchCustomerCategories]);
}
